export const attributeItems = [
  {
    id: '1',
    name: 'Амплитуда',
  },
  {
    id: '2',
    name: 'Частота',
  },
  {
    id: '3',
    name: 'Фаза',
  },
  {
    id: '4',
    name: 'Когерентность',
  },
  {
    id: '5',
    name: 'ML-разломы',
  },
  {
    id: '0',
    name: 'Другой',
  },
]
